import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

/**
 * Сервис содержит события таблицы
 */
@Injectable()
export class TableEventService {

    constructor() {
    }

    /**
     * Событие ресайза столбца таблицы
     */
    #isResizing$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public get isResizing$(): Observable<boolean> {
        return this.#isResizing$.asObservable();
    }

    public get isResizing(): boolean {
        return this.#isResizing$.getValue();
    }

    public set isResizing(data: boolean) {
        this.#isResizing$.next(data);
    }


}
